import { CSSProperties } from "react";

// Botão de ação das linhas de tabela (Registrar baixa / Marcar pago / etc.) — no layout "Razão" é
// um botão neutro pequeno (branco, borda fina), igual ao .btn-secondary.btn-sm. O parâmetro de cor
// ficou só por compatibilidade com quem chama: ação de linha não usa mais cor própria.
export function pillBtnStyle(_bg?: string): CSSProperties {
  return {
    fontSize: "12.5px",
    fontWeight: 500,
    padding: "5px 10px",
    borderRadius: "var(--radius-sm)",
    background: "var(--sp-surface)",
    color: "var(--sp-ink)",
    border: "1px solid var(--sp-rule)",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
}
